module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "csv-example"
  }, [_c('div', {
    staticClass: "csv-header"
  }, [_c('span', {
    staticClass: "csv-col"
  }, [_vm._v("SKU")]), _vm._v(" "), _c('span', {
    staticClass: "csv-col"
  }, [_vm._v("ASIN")]), _vm._v(" "), _c('span', {
    staticClass: "csv-col"
  }, [_vm._v("Product Name")]), _vm._v(" "), _c('span', {
    staticClass: "csv-col"
  }, [_vm._v("Current Price")]), _vm._v(" "), _c('span', {
    staticClass: "csv-col highlight"
  }, [_vm._v("COGS")]), _vm._v(" "), _c('span', {
    staticClass: "csv-col highlight"
  }, [_vm._v("Other Costs")])]), _vm._v(" "), _c('div', {
    staticClass: "csv-row"
  }, [_c('span', {
    staticClass: "csv-col"
  }, [_vm._v("SKU-12345")]), _vm._v(" "), _c('span', {
    staticClass: "csv-col"
  }, [_vm._v("B07K8XYZ")]), _vm._v(" "), _c('span', {
    staticClass: "csv-col"
  }, [_vm._v("\"Argan Body Wash\"")]), _vm._v(" "), _c('span', {
    staticClass: "csv-col"
  }, [_vm._v("24.99")]), _vm._v(" "), _c('span', {
    staticClass: "csv-col highlight"
  }, [_c('strong', [_vm._v("8.50")])]), _vm._v(" "), _c('span', {
    staticClass: "csv-col highlight"
  }, [_c('strong', [_vm._v("2.00")])])]), _vm._v(" "), _c('div', {
    staticClass: "csv-row"
  }, [_c('span', {
    staticClass: "csv-col"
  }, [_vm._v("SKU-67890")]), _vm._v(" "), _c('span', {
    staticClass: "csv-col"
  }, [_vm._v("B08SM5NNQ")]), _vm._v(" "), _c('span', {
    staticClass: "csv-col"
  }, [_vm._v("\"Body Lotion\"")]), _vm._v(" "), _c('span', {
    staticClass: "csv-col"
  }, [_vm._v("19.99")]), _vm._v(" "), _c('span', {
    staticClass: "csv-col highlight"
  }, [_c('strong', [_vm._v("5.25")])]), _vm._v(" "), _c('span', {
    staticClass: "csv-col highlight"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7d4673a3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pricing-costs/CSVExample.vue
// module id = 797
// module chunks = 2